import React from 'react';

const getFormat = (columns, index) => {
  if (columns === 1) {
    return 'widest';
  }

  if (columns === 2 && index === 0) {
    return 'wide';
  }

  return 'narrow';
};

const Section = ({
  children,
  className,
  title,
  align = false,
  displayTitle,
  height = 'fit-content',
}) => {
  const columns = React.Children.toArray(children).length;
  const shouldRenderTitle = title !== undefined && displayTitle;

  return (
    <div
      className={`section-component ${className} ${shouldRenderTitle ? 'has-title' : 'no-title'} with-${columns}-columns align-${
        align ? 'height' : 'none'
      } height-${height}`}
    >
      {shouldRenderTitle && <div className="section-title">{title}</div>}
      <div className="section-content">
        {React.Children.map(children, (child, index) => {
          if (child === null) {
            return null;
          }

          const format = getFormat(columns, index);
          return React.cloneElement(child, { format });
        })}
      </div>
    </div>
  );
};

export default Section;
